export default __webpack_public_path__ + "h11.png";